module.exports = __webpack_public_path__ + "assets/img/text-image-full.c03cf0d6.jpg";